export const CONTACT_ITEM_TYPES = {
  PHONE: "phone",
  EMAIL: "email",
  OTHER: "other",
  LINK: "link"
}
